<template>
  <div id="show-client-portal-attributes">
    <v-card class="mt-3">
      <v-card-title>
        Attributs client RADIUS
        <v-spacer></v-spacer>
        <v-btn
          v-if="isGrantedUser()"
          color="primary"
          icon
          @click.stop="openDialog = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <create-attribute-dialog
          :clientPortal="clientPortal"
          :open.sync="openDialog"
          v-if="openDialog && isGrantedUser()"
        ></create-attribute-dialog>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <attribute-datatable
          :clientPortal="clientPortal"
          :is-loading="isLoading"
          :first-load="firstLoad"
          :attributes="attributes"
        ></attribute-datatable>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, toRefs, ref } from "@vue/composition-api";
import AttributeDatatable from "@/components/Attribute/AttributeDatatable";
import { useAttributes } from "@/composables/attribute";
import CreateAttributeDialog from "@/components/Attribute/CreateAttributeDialog";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    clientPortal: Object,
  },
  components: {
    CreateAttributeDialog,
    AttributeDatatable,
  },
  setup(props) {
    /* Import des API */
    const { attributes, listAttributes, attributeData } = useAttributes();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const openDialog = ref(false);

    /* Cycle de vie */
    onMounted(() => {
      listAttributes(props.clientPortal.id);
    });

    return {
      attributes,
      ...toRefs(attributeData),
      openDialog,
      isGrantedUser,
    };
  },
};
</script>
